import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <header className="w-full bg-gradient-to-b from-amber-50 to-white" data-id="element-71">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24" data-id="element-72">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-73">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-74">
            <div className="space-y-4" data-id="element-75">
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight" data-id="element-76">
                Deja de decidir la cena.
              </h1>
              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed" data-id="element-77">
                Tu cerebro está cansado. Tu cena no debería exigirle más.
              </p>
            </div>

            <div className="space-y-3" data-id="element-78">
              <motion.a href="#pricing" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="inline-block bg-gray-900 hover:bg-gray-800 text-white font-semibold px-8 py-4 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg" data-id="element-79">
                Consigue el Sistema
              </motion.a>
            </div>
          </motion.div>

          {/* Hero Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/kofdfEHCske1eeVZuZy1iy/heylloyd-image-1770996757343.png" alt="Tablet mostrando Cena Sin Pensar en una cocina moderna" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-81" />
          </motion.div>
        </div>
      </div>
    </header>;
}